import z from 'zod'
import { ConceptStatusValueType, RAnyConceptStatus } from './ConceptStatus'
import { RImportResultLocation } from './ImportResultLocation'
import { MaterialArea } from './FormAppRelayInterface'

export enum AuditIndication {
	Urgent = 'Urgent',
}

export const RConceptStatusHistory = z.object({
	cid: z.string(),
	subconceptCid: z.nullable(z.string()),
	value: z.any(),
	valueType: z.enum(ConceptStatusValueType),
	updatedAt: z.string(),
	userId: z.string(),
	location: RImportResultLocation,
})

export type ConceptStatusHistory = z.infer<typeof RConceptStatusHistory>

const RImportMaterialClaim = z.object({
	area: z.enum(MaterialArea),
	id: z.string(),
})
export type ImportMaterialClaim = z.infer<typeof RImportMaterialClaim>

const RImportEncounter = z.object({
	SubmittingUserID: z.optional(z.string()),
	ClientDate: z.iso.date(),
	ClientDateTime: z.iso.datetime({offset: true}),
	Encounter_GUID: z.string(),
	LeaveBehindCode: z.nullable(z.string()),
	IndicatedAudit: z.array(z.object({
		Indication: z.enum(AuditIndication),
	})),
	MaterialClaims: z.optional(z.array(RImportMaterialClaim)),
})

const RImportFormResponse = z.object({
	Encounter: RImportEncounter,
	ConceptStatuses: z.array(RAnyConceptStatus),
	StatusHistory: z.array(RConceptStatusHistory),
	CalculationEngineErrors: z.optional(z.array(z.string())),
})

export const RImport = z.object({
	FormResponse: RImportFormResponse,
})
export type Import = z.infer<typeof RImport>
